import {
  SCENE_HIDE_MEASUREMENTS,
  SCENE_SHOW_MEASUREMENTS,
  SCENE_SET_PROPPING_VISIBILITY,
  SCENE_SET_ROOM,
  SCENE_SET_WALL_RESIZER_ACTIVE,
  SCENE_SET_WALL_RESIZER_DRAGGING,
  SCENE_SET_WALL_RESIZER_INACTIVE,
  SCENE_SET_RECT,
  SCENE_SET_MARGINS,
  SCENE_SHOW_SHEET,
  SCENE_HIDE_SHEET,
  SCENE_SET_PRELOAD_STATE,
} from '../actionConstants';
import { Action, CustomAction, RootAction } from '../../generalTypes';
import {
  DraggingWallResizer,
  NonInteraction,
  Room,
  ShowPropping,
  SceneRect,
  Margins,
} from './sceneTypes';

export const actionShowMeasurements = (): RootAction => ({
  type: SCENE_SHOW_MEASUREMENTS,
});

export const actionHideMeasurements =
  (meta: {}): CustomAction<NonInteraction> => ({
    type: SCENE_HIDE_MEASUREMENTS,
    meta,
  });

export const actionSetRoom = (room: Room): Action<Room> => ({
  type: SCENE_SET_ROOM,
  payload: room,
});

export const actionSetSceneRect = (
  sceneRect: SceneRect
): Action<SceneRect> => ({
  type: SCENE_SET_RECT,
  payload: sceneRect,
});

export const actionSetMargins = (margins: Margins): Action<Margins> => ({
  type: SCENE_SET_MARGINS,
  payload: margins,
});

export const actionSetProppingVisibility = (showPropping: ShowPropping) => ({
  type: SCENE_SET_PROPPING_VISIBILITY,
  payload: { showPropping },
});

export const actionSetWallResizerActive = (meta: {}): CustomAction<{}, {}> => ({
  type: SCENE_SET_WALL_RESIZER_ACTIVE,
  payload: {
    active: true,
  },
  meta,
});

export const actionSetWallResizerInactive = (meta: {}): CustomAction<
  {},
  {}
> => ({
  type: SCENE_SET_WALL_RESIZER_INACTIVE,
  payload: {
    active: false,
  },
  meta,
});

export const setDraggingWallResizer = (
  draggingWallResizer: DraggingWallResizer
): Action<DraggingWallResizer> => ({
  type: SCENE_SET_WALL_RESIZER_DRAGGING,
  payload: draggingWallResizer,
});

export const actionSetScenePreloadState = (preloadState: boolean) => ({
  type: SCENE_SET_PRELOAD_STATE,
  payload: { preloadState },
});

export const actionShowSceneSheet = (sheetType: string) => ({
  type: SCENE_SHOW_SHEET,
  payload: { sheetType },
});

export const actionHideSceneSheet = () => ({
  type: SCENE_HIDE_SHEET,
});
